import React from "react";
import CertificateButton from "../certificateButton/CertificateButton";
import Chain from "../chainLayout/ChainLayout";
import SignatureMetadata from "../signatureMetadata/SignatureMetadata";
import styles from "./signerChain.module.scss";
const SignerChain = ({ signature, certificates, selectedCertificateId, onSelectCertificate, }) => {
    const isChainSelected = signature.signature.cert_chain.some(([, childId]) => childId === selectedCertificateId);
    return (React.createElement(Chain.Layout, null,
        React.createElement(Chain.Line, { isActive: isChainSelected, className: styles["connection-line"] }),
        React.createElement(Chain.Label, null,
            React.createElement("div", { className: styles["label"] }, "Signer chain"),
            React.createElement("div", { className: styles["label-line"] })),
        React.createElement(Chain.Chain, { signatureType: "signer" }, signature.signature.cert_chain.map(([, childId]) => {
            var _a;
            return (React.createElement(CertificateButton, { key: childId, certificateId: childId, subject: (_a = certificates[childId]) === null || _a === void 0 ? void 0 : _a.subject, validationResults: signature.signature.cert_validation[childId], isActive: selectedCertificateId === childId, onClick: onSelectCertificate }));
        })),
        React.createElement(Chain.Signature, { signatureType: "signer" },
            React.createElement(SignatureMetadata, { title: "Signature", signature: signature }))));
};
export default SignerChain;
//# sourceMappingURL=SignerChain.js.map